import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import classNames from 'classnames';
import PortalCheckBox from '../../portal/controls/checkbox';
import SearchBox from '../../portal/searchBox';
import ScreenLoaderContainer from '../../portal/controls/screenLoaderContainer';
import styles from './style.scss';
import WindowedList from '../../portal/windowedList';

@inject('usersStore', 'teamsStore', 'teamUsersCheckboxListStore', 
    'teamMembersStore', 'translationsStore') @observer
export default class MemberList extends Component {

    shouldDispalyScreenLoader = true;
    filteredUsers = [];
    
    componentDidMount() {

        if(this.props.usersStore.users == undefined){
            this.props.usersStore.getAllUsers()
            .then(() => {
                
                this.buildCheckboxList();
            });
        }
        else{
            
            this.buildCheckboxList();
        }
    }

    buildCheckboxList(){
        const users = this.props.usersStore.users;
        this.props.teamUsersCheckboxListStore.buildCheckboxList(users, this.props.teamMembersStore.teamUsers);
    }

    toggle = id => {
        
        let list = [];

        this.props.teamUsersCheckboxListStore.selectableList.forEach(item => {
            
            if (item.id === id) {
                
                item.selected = !item.selected;
                
                if (item.selected) {
                    this.props.teamMembersStore.appnedUserId(id);
                }
                else {
                    this.props.teamMembersStore.removeUserId(id);
                }
            }

            list.push(item);
        });

        this.props.teamUsersCheckboxListStore.setSelectableList(list);
    }

    filterList = searchText => {
        
        const originalList = this.props.teamUsersCheckboxListStore.selectableList;

        const userItems =  originalList.map(u => ({...u}));
        if(searchText) {
            
            searchText = searchText.trim().toLowerCase();

            userItems.forEach((item) => {

                if(item.itemData.fullName.toLowerCase().indexOf(searchText) === -1
                    && item.itemData.userName.toLowerCase().indexOf(searchText) === -1
                    && item.itemData.email.toLowerCase().indexOf(searchText) === -1
                    && item.itemData.authenticationProvider.toLowerCase().indexOf(searchText) === -1) {

                        item.visible = false;
                    
                }
                else{
                    item.visible = true;
                }

            });
        }
        else {
            
            userItems.forEach((item) => {

                item.visible = true;
            });
        }

        this.props.teamUsersCheckboxListStore.setSelectableList(userItems);
    }
    
    rowRenderer = ({key, index, isScrolling, isVisible, style}) => {
        
        var item = this.filteredUsers[index];
        
        return (
            
            <div
                style={style}
                key={item.itemData.id}
                className={`member-list-checkbox-list-wrapper${item.selected ? ' selected' : ''}`}
            >
                <div className='left-selected-border'></div>
                <div className='checkbox'>
                    <PortalCheckBox
                        dataKey={ item.itemData.id }
                        checked={ item.selected }
                        onCheck={this.toggle}
                    />
                </div>
                    <div title={item.itemData.fullName} className='user-full-name ellipsis'>{item.itemData.fullName}</div>
                    <div title={item.itemData.userName} className='user-name ellipsis'>{item.itemData.userName}</div>
                    <div title={item.itemData.authenticationProvider} className='user-authentication-provider ellipsis'>{item.itemData.authenticationProvider}</div>
            </div>
        )
    }

    buildGridHeader()
    {
        return <div>
                    <div
                        className={classNames(styles.teamMembersListHeader)}
                    >
                        <span>
                            {this.props.translationsStore.translate('NAME')}
                        </span>
                        <span>
                            {this.props.translationsStore.translate('USER_NAME')}
                        </span>
                        <span>
                            {this.props.translationsStore.translate('AUTHENTICATION_PROVIDER')}
                        </span>
                    </div>
                </div>;
    }
    
    buildEmptyView()
    {
        return <div className='member-list-checkbox-list-wrapper no-results'>
                    <div>{this.props.translationsStore.translate('NO_USERS')}</div>
                </div>;
    }

    buildSearchBoxKeywords()
    {
        const keywords = {
            searchLibrary: this.props.translationsStore.translate('SEARCH_USERS'),
            clear: this.props.translationsStore.translate('CLEAR'),
        };

        return keywords;
    }

    render() {

        let emptyView = this.buildEmptyView();
        let header = null;

        if(this.props.teamUsersCheckboxListStore.selectableList.length === 0) {
            
            if(this.shouldDispalyScreenLoader === true) {

                emptyView = <ScreenLoaderContainer />;
                this.shouldDispalyScreenLoader = false;
            }
        }
        else {

            this.filteredUsers = this.props.teamUsersCheckboxListStore.selectableList.filter(i => i.visible);

            if (this.filteredUsers.length > 0) {
                
                emptyView = null;
                header = this.buildGridHeader();
            }
        }

        return(
            <div className='team-member-list'>
                <SearchBox
                    keywords={this.buildSearchBoxKeywords()}
                    search={this.filterList}
                />
                {header}
                {emptyView}
                <WindowedList
                    height='36vh'
                    rowCount={this.filteredUsers.length}
                    rowHeight={40}
                    rowRenderer={this.rowRenderer}
                />
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/teams/addTeamMemberDialog/list.jsx